<template>
  <div class="product-image-viewer">
    <!-- 缩略图区域 -->
    <div class="thumbnail-container">
      <div class="thumbnail-list-wrapper" ref="thumbnailListWrapper">
        <div class="thumbnail-list">
          <!-- 只显示7张缩略图 -->
          <div v-for="(image, index) in visibleThumbnails" :key="index" class="thumbnail-item" :class="{
            active: currentIndex === (thumbnailStartIndex + index),
            'hover-effect': hoverIndex === (thumbnailStartIndex + index)
          }" @mouseenter="handleThumbnailHover(thumbnailStartIndex + index)" @mouseleave="handleThumbnailLeave"
            @click="switchToImage(thumbnailStartIndex + index)">
            <!-- 1:1比例缩略图容器 -->
            <div class="thumbnail-aspect-ratio">
              <img :src="image" :alt="`缩略图 ${thumbnailStartIndex + index + 1}`" class="thumbnail-image" loading="lazy"
                @load="handleThumbnailLoad" @error="handleThumbnailError" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 主图区域 -->
    <div class="main-image-container">
      <div class="main-image-wrapper" @mouseenter="enterMagnifier" @mouseleave="leaveMagnifier"
        @mousemove="handleMagnifierMove" ref="mainImageWrapper" style="position: relative; width: 100%; height: 100%;">
        <!-- 主图1:1比例容器 -->
        <div class="main-image-aspect-ratio">
          <img :src="currentMainImage" alt="商品主图" class="main-image" ref="mainImageElement" loading="lazy"
            @load="handleMainImageLoad" style="width: 100%; height: 100%; object-fit: contain;" />
        </div>

        <!-- 放大镜遮罩层 -->
        <!-- <div class="magnifier-mask" 
        v-show="showMagnifier && magnifierEnabled && imageLoaded" 
        :style="{
          position: 'absolute',
          left: `${magnifierData.maskLeft}px`,
          top: `${magnifierData.maskTop}px`,
          width: `${magnifierData.maskWidth}px`,
          height: `${magnifierData.maskHeight}px`,
          backgroundColor: 'rgba(255, 255, 255, 0.3)',
          border: '1px solid #ddd',
          cursor: 'move',
          pointerEvents: 'none',
          zIndex: 10
        }"></div> -->
        <!-- 放大预览区域 -->
        <!-- <div class="magnifier-preview" v-show="false" :style="{
          position: 'absolute',
          left: 'calc(100% + 20px)',  /* 放置在主图右侧，间隔20px */
          top: '0',
          width: '400px',  /* 固定预览区域宽度 */
          height: '400px',  /* 固定预览区域高度 */
          border: '1px solid #ddd',
          borderRadius: '4px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          overflow: 'hidden',
          backgroundColor: '#fff',
          zIndex: '1000'
        }">
          <div class="magnifier-preview-image" :style="{
            position: 'absolute',
            width: `${magnifierData.zoomRatio * 100}%`,
            height: `${magnifierData.zoomRatio * 100}%`,
            transform: `translate(${-bgX}px, ${-bgY}px)`,
            backgroundImage: `url(${currentImageUrl})`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '0 0'
          }"></div>
        </div> -->

        <!-- 主图导航箭头 -->
        <div class="main-nav-arrows" v-show="showMainArrows && imageLoaded">
          <button class="nav-arrow prev-arrow" @click="prevMainImage" v-show="showMainArrows"
            :disabled="currentIndex === 0" :class="{ disabled: currentIndex === 0 }">
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
            </svg>
          </button>
          <button class="nav-arrow next-arrow" 
          @click="nextMainImage" 
          v-show="showMainArrows"
            :disabled="currentIndex === images.length - 1" 
            :class="{ disabled: currentIndex === images.length - 1 }">
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
            </svg>
          </button>
        </div>

        <!-- 图片加载提示 -->
        <div class="image-loading" v-if="!imageLoaded">
          <div class="loading-spinner"></div>
          <span class="loading-text">图片加载中...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductImageViewer',
  props: {
    images: {
      type: Array,
      required: true,
      default: () => []
    },
    magnifierEnabled: {
      type: Boolean,
      default: false
    },
    magnifierZoom: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      currentIndex: 0,
      showMainArrows: false,
      // showMagnifier: false,
      thumbnailStartIndex: 0,
      hoverIndex: -1,
      magnifierData: {
        maskLeft: 0,
        maskTop: 0,
        maskWidth: 120,
        maskHeight: 120,
        bgY: 0,
        bgX: 0
      },
      containerRect: null,
      screenType: 'medium',
      isMobile: false,
      imageLoaded: false,
      imageDimensions: {
        naturalWidth: 0,
        naturalHeight: 0,
        displayWidth: 0,
        displayHeight: 0
      },
      loadedThumbnails: new Set()
    };
  },
  computed: {
    currentMainImage() {
      return this.images[this.currentIndex] || '';
    },
    // 计算可见的缩略图（最多显示7张）
    visibleThumbnails() {
      const maxVisible = 7;

      if (this.images.length <= maxVisible) {
        return this.images;
      }

      let startIndex = this.currentIndex;
      let endIndex = startIndex + maxVisible;

      if (endIndex > this.images.length) {
        startIndex = this.images.length - maxVisible;
        endIndex = this.images.length;
      }

      startIndex = Math.max(0, startIndex);
      this.thumbnailStartIndex = startIndex;

      return this.images.slice(startIndex, endIndex);
    },
    // 根据屏幕类型计算缩略图尺寸
    thumbnailSize() {
      switch (this.screenType) {
        case 'xlarge':
          return 85; // 1920px及以上
        case 'large':
          return 65; // 1440px-1919px
        case 'medium':
          return 55; // 751px-1439px
        case 'small':
          return 45; // 小于751px
        default:
          return 55;
      }
    },
    // 根据屏幕类型计算主图尺寸
    mainImageSize() {
      switch (this.screenType) {
        case 'xlarge':
          return 630; // 1920px及以上
        case 'large':
          return 570; // 1440px-1919px
        case 'medium':
          return 500; // 751px-1439px
        case 'small':
          return 400; // 小于751px
        default:
          return 500;
      }
    },
    // 缩略图容器高度计算
    thumbnailContainerHeight() {
      const maxVisible = 7;
      const thumbnailSize = this.thumbnailSize;
      const gap = 5; // 固定间距5px

      return maxVisible * (thumbnailSize + gap);
    },
    maskStyle() {
      return {
        left: `${this.magnifierData.maskLeft}px`,
        top: `${this.magnifierData.maskTop}px`,
        width: `${this.magnifierData.maskWidth}px`,
        height: `${this.magnifierData.maskHeight}px`
      };
    },
    // 当前图片URL - 补充完整
    currentImageUrl() {
      // 边界检查
      if (!this.images || this.images.length === 0) {
        return this.getDefaultImageUrl();
      }

      // 确保索引有效
      const validIndex = Math.max(0, Math.min(this.currentIndex, this.images.length - 1));

      // 返回当前图片URL
      return this.images[validIndex];
    },
    previewStyle() {
      return {
        position: 'absolute',
        left: 'calc(100% + 20px)',  // 放置在主图右侧，间隔20px
        top: '0',
        width: '400px',
        height: '400px',
        border: '1px solid #ddd',
        borderRadius: '4px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        overflow: 'hidden',
        backgroundColor: '#fff',
        zIndex: '1000',
        display: this.showMagnifier && this.magnifierEnabled && this.imageLoaded ? 'block' : 'none'
      };
    },
    previewImageStyle() {
      if (!this.imageLoaded) return {};

      const bgX = this.magnifierData.bgX || 0;
      const bgY = this.magnifierData.bgY || 0;
      const zoomRatio = this.magnifierData.zoomRatio || 2;

      return {
        position: 'absolute',
        width: `${zoomRatio * 100}%`,
        height: `${zoomRatio * 100}%`,
        transform: `translate(${-bgX}px, ${-bgY}px)`,
        backgroundImage: `url(${this.currentImageUrl})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '0 0'
      };
    },
    // 是否可切换到上一张
    canGoPrev() {
      return this.currentIndex > 0;
    },

    // 是否可切换到下一张
    canGoNext() {
      return this.currentIndex < this.images.length - 1;
    }
  },
  methods: {
    // 检测屏幕类型
    detectScreenType() {
      const width = window.innerWidth;

      if (width >= 1920) {
        this.screenType = 'xlarge';
        this.isMobile = false;
      } else if (width >= 1440 && width <= 1919) {
        this.screenType = 'large';
        this.isMobile = false;
      } else if (width >= 751 && width <= 1439) {
        this.screenType = 'medium';
        this.isMobile = false;
      } else {
        this.screenType = 'small';
        this.isMobile = true;
      }
    },

    getPreviewWidth() {
      switch (this.screenType) {
        case 'xlarge':
          return 630;
        case 'large':
          return 570;
        case 'medium':
          return 500;
        case 'small':
          return 400;
        default:
          return 500;
      }
    },

    getPreviewHeight() {
      return this.getPreviewWidth();
    },

    getPreviewLeft() {
      const mainImageWidth = this.mainImageSize;
      return mainImageWidth + 20;
    },

    getMainImageWidth() {
      return this.mainImageSize;
    },

    // 主图加载完成处理
    handleMainImageLoad(event) {
      const img = event.target;

      // 确保图片完全加载
      this.imageLoaded = true;

      // 获取图片尺寸
      this.imageDimensions = {
        naturalWidth: img.naturalWidth,
        naturalHeight: img.naturalHeight,
        displayWidth: img.clientWidth,
        displayHeight: img.clientHeight
      };

      // 初始化放大镜参数
      this.$nextTick(() => {
        this.initMagnifier();
      });
    },
    initMagnifier() {
      const container = this.$refs.mainImageWrapper;
      if (!container) return;

      const containerRect = container.getBoundingClientRect();

      // 设置默认放大镜参数
      this.magnifierData = {
        maskWidth: 120,
        maskHeight: 120,
        zoomRatio: 2,
        maskLeft: 0,
        maskTop: 0,
        bgX: 0,
        bgY: 0
      };

      // 触发一次更新
      this.$forceUpdate();
    },

    // 切换到指定图片
    switchToImage(index) {
      if (index >= 0 && index < this.images.length) {
        this.currentIndex = index;
        this.imageLoaded = false; // 切换图片时重置加载状态
        this.$set(this.magnifierData, 'maskLeft', 0);
        this.$set(this.magnifierData, 'maskTop', 0);
        this.showMagnifier = false;

        // 等待图片加载完成
        this.$nextTick(() => {
          if (this.$refs.mainImageElement) {
            const img = this.$refs.mainImageElement;
            if (img.complete) {
              this.handleMainImageLoad({ target: img });
            }
          }
        });
      }
    },

    // 上一张图片
    prevMainImage() {
      if (this.currentIndex > 0) {
        this.switchToImage(this.currentIndex - 1);
      }
    },

    // 下一张图片
    nextMainImage() {
      if (this.currentIndex < this.images.length - 1) {
        this.switchToImage(this.currentIndex + 1);
      }
    },

    // 缩略图鼠标悬停处理
    handleThumbnailHover(index) {
      this.hoverIndex = index;
      this.switchToImage(index);
    },

    handleThumbnailLeave() {
      this.hoverIndex = -1;
    },

    // 缩略图加载成功处理
    handleThumbnailLoad(event) {
      const imgIndex = event.target.dataset.index;
      if (imgIndex !== undefined) {
        this.loadedThumbnails.add(parseInt(imgIndex));
      }
    },

    // 缩略图加载失败处理
    handleThumbnailError(event) {
      const imgIndex = event.target.dataset.index;
      console.warn(`缩略图 ${imgIndex} 加载失败`);
      event.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIGZpbGw9IiNGRkZGRkUiLz48cGF0aCBkPSJNMzUgMzVoMzB2MzBIMzV6IiBmaWxsPSIjRkZGIi8+PHBhdGggZD0iTTUwIDIwYzE2LjU0IDAgMzAgMTMuNDYgMzAgMzBzLTEzLjQ2IDMwLTMwIDMwLTMwLTEzLjQ2LTMwLTMwIDEzLjQ2LTMwIDMwLTMwem0wIDVjLTEzLjggMC0yNSAxMS4yLTI1IDI1czExLjIgMjUgMjUgMjUgMjUtMTEuMiAyNS0yNS0xMS4yLTI1LTI1LTI1eiIgZmlsbD0iI0RERCIvPjwvc3ZnPg==';
    },

    // 进入放大镜区域
    enterMagnifier() {
      if (this.magnifierEnabled && !this.isMobile && this.imageLoaded) {
        this.showMagnifier = true;
        this.showMainArrows = true;
        this.updateContainerRect();
      }
    },

    // 离开放大镜区域
    leaveMagnifier() {
      this.showMagnifier = false;
      this.showMainArrows = false;
    },

    // 更新容器位置信息
    updateContainerRect() {
      if (this.$refs.mainImageWrapper) {
        this.containerRect = this.$refs.mainImageWrapper.getBoundingClientRect();
      }
    },

    // 放大镜移动处理
    handleMagnifierMove(event) {
      if (!this.showMagnifier || !this.magnifierEnabled || this.isMobile || !this.imageLoaded) return;

      const container = this.$refs.mainImageWrapper;
      if (!container) return;

      const containerRect = container.getBoundingClientRect();
      const maskWidth = this.magnifierData.maskWidth || 100;
      const maskHeight = this.magnifierData.maskHeight || 100;

      // 计算鼠标在容器内的相对位置
      let x = event.clientX - containerRect.left;
      let y = event.clientY - containerRect.top;

      // 边界处理 - 修正文档中的错误
      const maxLeft = Math.max(0, containerRect.width - maskWidth);
      const maxTop = Math.max(0, containerRect.height - maskHeight);

      // 计算遮罩层位置（居中于鼠标）
      let maskLeft = Math.max(0, Math.min(x - maskWidth / 2, maxLeft));
      let maskTop = Math.max(0, Math.min(y - maskHeight / 2, maxTop));

      // 更新遮罩层位置
      this.$set(this.magnifierData, 'maskLeft', maskLeft);
      this.$set(this.magnifierData, 'maskTop', maskTop);

      // 计算放大图片的偏移量（文档中代码不完整）
      if (maxLeft > 0) {
        const bgX = (maskLeft / maxLeft) * (this.imageDimensions.naturalWidth - containerRect.width);
        this.$set(this.magnifierData, 'bgX', bgX);
      }

      if (maxTop > 0) {
        const bgY = (maskTop / maxTop) * (this.imageDimensions.naturalHeight - containerRect.height);
        this.$set(this.magnifierData, 'bgY', bgY);
      }
    },

    // 更新放大预览图片位置
    updatePreviewImagePosition(maskLeft, maskTop) {
      if (!this.imageLoaded) return;

      // 计算放大比例
      const zoomLevel = this.magnifierZoom || 2;
      const previewWidth = this.getPreviewWidth();
      const previewHeight = this.getPreviewHeight();

      // 获取主图容器尺寸
      const container = this.$refs.mainImageWrapper;
      if (!container) return;

      const containerRect = container.getBoundingClientRect();
      const maskWidth = this.magnifierData.maskWidth;
      const maskHeight = this.magnifierData.maskHeight;

      // 计算最大可移动范围
      const maxLeft = containerRect.width - maskWidth;
      const maxTop = containerRect.height - maskHeight;

      // 计算放大图片的偏移量（方向相反，倍数放大）
      let bgX = 0;
      let bgY = 0;

      if (maxLeft > 0) {
        bgX = -(maskLeft * zoomLevel * (this.imageDimensions.naturalWidth / containerRect.width));
      }

      if (maxTop > 0) {
        bgY = -(maskTop * zoomLevel * (this.imageDimensions.naturalHeight / containerRect.height));
      }

      // 更新预览图片样式
      const previewImage = document.querySelector('.magnifier-preview-image');
      if (previewImage) {
        previewImage.style.backgroundPosition = `${bgX}px ${bgY}px`;
      }
    },

    // 处理窗口大小变化
    handleResize() {
      this.detectScreenType();
      this.updateContainerRect();
      if (this.$refs.mainImageElement && this.imageLoaded) {
        const img = this.$refs.mainImageElement;
        this.imageDimensions.displayWidth = img.clientWidth;
        this.imageDimensions.displayHeight = img.clientHeight;
      }
    },
    
     // 重置数据到原始值
    resetToOriginalData() {
      // 重置 allGoodsImgs
      this.allGoodsImgs = [];
      
      // 重置放大镜相关数据
      this.magnifierData = {
        maskLeft: 0,
        maskTop: 0,
        maskWidth: 100,
        maskHeight: 100,
        // 其他放大镜相关数据的初始值
      };
      
     this.currentIndex=0
      this.showMainArrows=false,
      // showMagnifier: false,
      this.thumbnailStartIndex=0
      this.hoverIndex=-1
      
      // 重置其他需要恢复的数据...
    },
  },
  mounted() {
    if (this.images.length > 0) {
      this.currentIndex = 0;
    }

    this.detectScreenType();
    window.addEventListener('resize', this.handleResize);

    // 初始化时获取主图尺寸
    this.$nextTick(() => {
      if (this.$refs.mainImageElement) {
        const img = this.$refs.mainImageElement;
        if (img.complete) {
          this.handleMainImageLoad({ target: img });
        }
      }
    });
  },
  watch: {
    // 监听图片切换，重置放大镜状态
    currentIndex() {
      this.imageLoaded = false;
      this.showMagnifier = false;
    },
    '$route.query.goodsId': {
      handler(newGoodsId, oldGoodsId) {
        if (newGoodsId !== oldGoodsId) {
          // 重置所有数据到原始值
          this.resetToOriginalData();
          
        }
      },
      immediate: true
    }
    
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style scoped>
.product-image-viewer {
  display: flex;
  gap: 20px;
  margin: 0 auto;
  padding: 20px;
  background: #fff;
  transition: all 0.3s ease;
  box-sizing: border-box;
  max-width: 1400px;
}

/* 缩略图容器 */
.thumbnail-container {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.thumbnail-list-wrapper {
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: #ddd transparent;
  padding-right: 4px;
}

.thumbnail-list-wrapper::-webkit-scrollbar {
  width: 4px;
}

.thumbnail-list-wrapper::-webkit-scrollbar-track {
  background: transparent;
}

.thumbnail-list-wrapper::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 2px;
}

.thumbnail-list-wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
}

.thumbnail-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
  /* 固定间距5px */
}

.thumbnail-item {
  position: relative;
  cursor: pointer;
  overflow: visible;
  transition: all 0.3s ease;
  opacity: 0.7;
  flex-shrink: 0;
}

/* 1:1比例缩略图容器 */
.thumbnail-aspect-ratio {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  overflow: hidden;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.thumbnail-item:hover .thumbnail-aspect-ratio {
  opacity: 1;
  border-color: #ff5000;
  /* transform: scale(1.03); */
}

.thumbnail-item.active .thumbnail-aspect-ratio {
  opacity: 1;
  border-color: #ff5000;
  /* transform: scale(1.03); */
  /* box-shadow: 0 4px 12px rgba(255, 80, 0, 0.3); */
}

.thumbnail-item.hover-effect .thumbnail-aspect-ratio {
  opacity: 0.9;
  border-color: #ffa500;
}

.thumbnail-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
  background-color: #f5f5f5;
}

.thumbnail-item:hover .thumbnail-image {
  transform: scale(1.1);
}

/* 主图容器 */
.main-image-container {
  position: relative;
  flex: 1;
  min-width: 0;
}

.main-image-wrapper {
  position: relative;
  width: 100%;
  /* border: 1px solid #e5e5e5; */
  /* border-radius: 8px; */
  overflow: hidden;
  cursor: pointer;
}

/* 主图1:1比例容器 */
.main-image-aspect-ratio {
  position: relative;
  width: 100%;
  padding-bottom: 100%;
  background-color: #f8f8f8;
  overflow: hidden;
}

.main-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.main-image-wrapper:hover .main-image {
  transform: scale(1.02);
}

/* 放大镜遮罩层 */
.magnifier-mask {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.3);
  border: 1px solid #ddd;
  cursor: move;
  pointer-events: none;
  z-index: 10;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1) inset;
  transition: all 0.1s ease;
  display: block;
}

/* 放大预览区域 */
.magnifier-preview {
  position: absolute;
  border: 1px solid #ddd;
  background-color: white;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  z-index: 20;
  pointer-events: none;
  display: block;
  visibility: visible;
  opacity: 1;
  transition: opacity 0.3s ease;
}

.magnifier-preview-image {
  position: absolute;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  top: 0;
  left: 0;
}

/* 主图导航箭头 */
.main-nav-arrows {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  z-index: 30;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.main-image-wrapper:hover .main-nav-arrows {
  opacity: 1;
  pointer-events: auto;
}

.nav-arrow {
  width: 48px;
  height: 48px;
  background-color: rgba(255, 255, 255, 0.9);
  border: 1px solid #ddd;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  pointer-events: auto;
}

.nav-arrow:hover:not(.disabled) {
  background-color: rgba(255, 255, 255, 0.95);
  border-color: #ff5000;
  transform: scale(1.1);
  box-shadow: 0 4px 20px rgba(255, 80, 0, 0.3);
}

.nav-arrow.disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.nav-arrow svg {
  fill: #333;
  transition: fill 0.3s ease;
}

.nav-arrow:hover:not(.disabled) svg {
  fill: #ff5000;
}

/* 图片加载提示 */
.image-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 5;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #ff5000;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

.loading-text {
  color: #666;
  font-size: 14px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* 响应式设计 - 使用CSS媒体查询实现[6](@ref)[7](@ref) */
/* 小屏幕设备（小于751px） */
@media (max-width: 750px) {
  .product-image-viewer {
    flex-direction: column;
    max-width: 100%;
    padding: 12px;
    gap: 16px;
  }

  .thumbnail-container {
    width: 100%;
    order: 2;
  }

  .thumbnail-list-wrapper {
    height: 350px;
    /* 7张缩略图 * (45px + 5px间距) = 350px */
    overflow-x: auto;
    overflow-y: hidden;
  }

  .thumbnail-list {
    flex-direction: row;
    height: 45px;
    gap: 5px;
  }

  .thumbnail-item {
    width: 45px;
    height: 45px;
    flex-shrink: 0;
  }

  .thumbnail-aspect-ratio {
    width: 45px;
    height: 45px;
  }

  .main-image-container {
    width: 100%;
    height: 400px;
    order: 1;
  }

  .main-image-wrapper {
    height: 400px;
  }

  .main-image-aspect-ratio {
    padding-bottom: 100%;
  }

  .magnifier-preview {
    display: none !important;
  }

  .magnifier-mask {
    display: none !important;
  }
}

/* 中等屏幕（751px - 1439px） */
@media (min-width: 751px) and (max-width: 1439px) {
  .product-image-viewer {
    max-width: 1000px;
    gap: 20px;
  }

  .thumbnail-container {
    width: 60px;
    /* 缩略图宽度55px + 边框2px*2 + 内边距 */
  }

  .thumbnail-list-wrapper {
    height: 420px;
    /* 7张缩略图 * (55px + 5px间距) = 420px */
  }

  .thumbnail-item {
    width: 55px;
    height: 55px;
  }

  .thumbnail-aspect-ratio {
    width: 55px;
    height: 55px;
  }

  .main-image-container {
    width: 500px;
    height: 500px;
  }

  .main-image-wrapper {
    height: 500px;
  }

  .main-image-aspect-ratio {
    padding-bottom: 100%;
  }

  .magnifier-preview {
    width: 500px;
    height: 500px;
    left: 520px;
    /* 主图宽度500px + 间距20px */
  }
}

/* 大屏幕（1440px - 1919px） */
@media (min-width: 1440px) and (max-width: 1919px) {
  .product-image-viewer {
    max-width: 1200px;
    gap: 20px;
  }

  .thumbnail-container {
    width: 70px;
    /* 缩略图宽度65px + 边框2px*2 + 内边距 */
  }

  .thumbnail-list-wrapper {
    height: 490px;
    /* 7张缩略图 * (65px + 5px间距) = 490px */
  }

  .thumbnail-item {
    width: 65px;
    height: 65px;
  }

  .thumbnail-aspect-ratio {
    width: 65px;
    height: 65px;
  }

  .main-image-container {
    width: 570px;
    height: 570px;
  }

  .main-image-wrapper {
    height: 570px;
  }

  .main-image-aspect-ratio {
    padding-bottom: 100%;
  }

  .magnifier-preview {
    width: 570px;
    height: 570px;
    left: 590px;
    /* 主图宽度570px + 间距20px */
  }
}

/* 超大屏幕（1920px及以上） */
@media (min-width: 1920px) {
  .product-image-viewer {
    max-width: 1500px;
    gap: 30px;
    padding: 30px;
  }

  .thumbnail-container {
    width: 90px;
    /* 缩略图宽度85px + 边框2px*2 + 内边距 */
  }

  .thumbnail-list-wrapper {
    height: 630px;
    /* 7张缩略图 * (85px + 5px间距) = 630px */
  }

  .thumbnail-item {
    width: 85px;
    height: 85px;
  }

  .thumbnail-aspect-ratio {
    width: 85px;
    height: 85px;
  }

  .main-image-container {
    width: 630px;
    height: 630px;
  }

  .main-image-wrapper {
    height: 630px;
  }

  .main-image-aspect-ratio {
    padding-bottom: 100%;
  }

  .magnifier-preview {
    width: 630px;
    height: 630px;
    left: 650px;
    /* 主图宽度630px + 间距20px */
  }
}

/* 触摸设备优化 */
@media (pointer: coarse) {

  .thumbnail-item,
  .nav-arrow {
    min-height: 44px;
    min-width: 44px;
  }
}

/* 深色模式支持 */
/* @media (prefers-color-scheme: dark) {
  .product-image-viewer {
    background: #1a1a1a;
  }

  .main-image-wrapper {
    border-color: #333;
  }

  .thumbnail-aspect-ratio {
    border-color: #333;
  }

  .thumbnail-item:hover .thumbnail-aspect-ratio {
    border-color: #ff5000;
  }

  .thumbnail-item.active .thumbnail-aspect-ratio {
    border-color: #ff5000;
  }

  .thumbnail-image {
    background-color: #2a2a2a;
  }

  .main-image-aspect-ratio {
    background-color: #2a2a2a;
  }
} */

/* 减少动画偏好支持 */
@media (prefers-reduced-motion: reduce) {

  .product-image-viewer,
  .thumbnail-list,
  .thumbnail-item,
  .thumbnail-image,
  .nav-arrow,
  .main-image {
    transition: none;
  }

  .loading-spinner {
    animation: none;
  }
}
</style>
